(() => {
  const inputButton = document.querySelector(".input-button")
  const up = inputButton && inputButton.querySelector(".button-up")
  const down = inputButton && inputButton.querySelector(".button-down")
  const input = inputButton && inputButton.querySelector(".input-button__input")
  // const value = +input.value
  // const step = 1;
  const step = input && +input.getAttribute("data-step")
  const min = input && +input.getAttribute("min")
  const max = input && +input.getAttribute("max")

  // console.log(inputButton, up, down, input, step, min, max)

  const changeVal = (isUp) => {
    const oldVal = +input.value.replace(" ", "")
    const newVal = isUp ? oldVal + step : oldVal - step
    // console.log(oldVal, newVal, "changeVal")

    if (isUp && newVal <= max) {
      input.value = newVal
    }

    if (!isUp && newVal >= min) {
      input.value = newVal
    }
  }
  if (up) {
    up.addEventListener("click", () => changeVal(true))
  }
  if (down) {
    down.addEventListener("click", () => changeVal(false))
  }
})()



// WEBPACK FOOTER //
// ./src/blocks/profit/profit.js